import styled from "@emotion/styled";
import { Container, Grid, Typography } from "@mui/material";

const AboutWrapper = styled(Container)`
    background:#000B29;
    padding-top:60px;
    padding-bottom:50px;
    display:flex;
    justify-content:center;
    @media(max-width:749px) and (min-width: 600px){
        padding-top:60px;
        padding-bottom:50px;
    }
    @media(max-width:600px){
        padding-top:40px;
        padding-bottom:50px;
    }
`
const P = styled.p`
    font-size:14px;
    font-family:Poppins;
    text-transform:uppercase;
    padding-right:20px;
    color:#fff;
    @media (max-width: 900px)and (min-width: 768px){
        padding-right:20px;
    }
    @media(max-width: 600px){
        text-align:center;
        padding-right:0px;
    }
`
const Heading = styled(Typography)`
    font-size:25px;
    font-family:Emulogic-zrEw;
    font-weight:400;
    text-transform:uppercase;
    color:#fff;
    @media(max-width: 600px){
        text-align:center;
    }
`
const SocialWrapper = styled.div`
    display: flex;
    align-items: center;
    @media (max-width: 600px){
        justify-content: center;
    }
`
const SocialImg = styled.img`
    margin:0px 5px;
    @media (max-width: 1250px) and (min-width: 900px){
    width:40px;
    max-width:100%;
    }
`
const SocialA = styled.a`
    display:flex;
    align-items:center;
`
const VideoGrid = styled(Grid)`
    position:relative;
    z-index: 0;
    @media (max-width: 749px){
        margin-top:20px;
    }
`
const VideoBg = styled.img`
    width:100%;
    height: auto;
`
const Video = styled.video`
    position: absolute;
    left: 7%;
    top: 7%;
    height: auto;
    width: calc(100% - 18%);
    z-index: -1;
`
const ContentGrid = styled(Grid)`
    display:flex;
    flex-direction:column;
`
const WrapperGrid = styled(Grid)`
    @media(min-width:900px){
        display:flex;
        justify-content:space-between;
    }
`
const HeaderLinks = styled.div`
    background-image:url("./assets/link-bg.png");
    padding:10px 12px;
    background-size: contain;
    background-repeat: no-repeat;
    margin:20px 0px 0px 0px;
    @media (max-width:650px){
        padding:6px 12px;
    }
    @media(min-width: 1024px){
        margin:50px 0px;
    }
`
const Links = styled.a`
    color:#000;
    font-family:Emulogic-zrEw;
    font-size:15px;
    text-decoration:none;
    @media (max-width:650px){
        font-size:12px;
    }
`
function About() {
    return (
        <AboutWrapper maxWidth="xxl" id="about">
            <WrapperGrid container item xs={12} md={12} xl={10}>
                <ContentGrid item xs={12} sm={7} md={6}>
                    <div>
                        <Heading variant="h1" data-aos="fade-right">About</Heading>
                        <Heading variant="h1" data-aos="fade-right">The Project</Heading>
                        <P data-aos="fade-right">Pacman is a groundbreaking project that merges the classic Pacman game with the power of blockchain technology.
                            Earn rewards and compete with players worldwide as you navigate through the exciting mazes.
                            Immerse yourself in a decentralized gaming experience like never before!
                        </P>
                    </div>
                  
                    <HeaderLinks  data-aos="zoom-in"><Links href="https://game.pacman.plus/">Play Now</Links></HeaderLinks>
                </ContentGrid>
                <VideoGrid item xs={12} sm={5} md={5} data-aos="fade-left">
                    <VideoBg src="./assets/video-bg.png" />
                    <Video autoPlay loop muted playsInline>
                        <source src="./assets/movie_001.mp4" type="video/mp4" />
                    </Video>
                </VideoGrid>
            </WrapperGrid>
        </AboutWrapper>
    );
}

export default About;